import { useDispatch } from "react-redux";

import { ReactComponent as IconDocument } from "assets/svg/Document.svg";

import { Box, Typography } from "@mui/material";

import { FileTypes, getResponseFileStart } from "redux-store/static/redux/file";
import pxToRem from "theme/base/pxToRem";

import { getFileExtension } from "helper/utils";
import {
  isImage,
  PDF_EXTENSION,
} from "components/common/Form/FormUpload/const";
import ImagePreview from "components/common/Form/FormUpload/ImagePreview";

export interface IPropsDocForm {
  path: string;

  originalFilename: string;
}

const DocForm = ({ content }: { content: IPropsDocForm }) => {
  const dispatch = useDispatch();

  const isFileImage = isImage(content?.originalFilename);

  const fileExtension = getFileExtension(content?.originalFilename);

  const getFileContent = (callbackFunction: Function) => {
    const type =
      fileExtension === PDF_EXTENSION.PDF
        ? FileTypes.PDF_DOCUMENT
        : FileTypes.DOC;
    dispatch(
      getResponseFileStart({
        url: content.path,
        type,
        callback: (data) => {
          callbackFunction(data);
        },
      })
    );
  };

  const handleDownload = () => {
    getFileContent((data) => {
      const link = document.createElement("a");
      link.href = data;
      link.download = content.originalFilename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const handleView = () => {
    if (fileExtension === PDF_EXTENSION.PDF) {
      handleDownload();
      return;
    }
    getFileContent((data) => {
      window.open(data, "_blank")?.focus();
    });
  };

  return (
    <Box
      display="flex"
      gap={2}
      alignItems={"center"}
      sx={{
        cursor: "pointer",
        height: pxToRem(100),
        width: pxToRem(100),
        padding: pxToRem(8),
        paddingLeft: 0,
        img: {
          height: pxToRem(92),
          borderRadius: pxToRem(8),
        },
      }}
    >
      {isFileImage ? (
        <>
          <ImagePreview
            url={content.path}
            fileName={content?.originalFilename}
          />
        </>
      ) : (
        <Box onClick={handleView}>
          <IconDocument />
          <Box display="flex" flexDirection="column">
            <Typography
              sx={(theme) => ({
                fontSize: theme.typography.size.xs_12,
                maxWidth: pxToRem(100),
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
              })}
            >
              {content.originalFilename}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default DocForm;
